import _ from 'lodash'
import { Product } from '@/modules/product'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Paginación de productos
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ProductPagination {
    public totalPages = 0
    public totalRecords = 0
    public products: Product[] = []

    public static deserialize (data: KeyValuePair) {
        const pagination = new this();
        pagination.totalRecords = _.toInteger(data.total_records)
        pagination.totalPages = _.toInteger(data.total_pages)
        pagination.products = data.products.map((p: KeyValuePair) => Product.deserialize(p))

        return pagination
    }
}
